import { NgClass, NgFor, NgIf } from '@angular/common';
import { ChangeDetectorRef, Component, CUSTOM_ELEMENTS_SCHEMA, OnInit, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs';
import { LocalMessageService } from '../../services/local-message.service';
import { DialogService, DynamicDialogModule, DynamicDialogRef } from 'primeng/dynamicdialog';
import { MapPreviewComponent } from '../map-preview/map-preview.component';
import { getInformation } from '../../constants/ci-information.constant';
import Swiper from 'swiper';
import { TransportMapComponent } from '../../../map/components/transport-map/transport-map.component';
import { TooltipModule } from 'primeng/tooltip';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-local-message',
  standalone: true,
  imports: [NgFor, NgIf, DynamicDialogModule, NgClass, TooltipModule, RouterModule],
  providers: [DialogService],
  templateUrl: './local-message.component.html',
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class LocalMessageComponent implements OnInit {

  @ViewChild('swiper', { static: false }) 
  public swiper?: Swiper;

  public messages: any[] = [];
  public auxMessages: any[] = [];
  public isShaking: boolean = false;
  public showInformation: boolean = false;
  public hasChanges: boolean = true;
  public firstInteraction: boolean = true;
  private _ref: DynamicDialogRef | undefined;
  private _subscription: Subscription = new Subscription();

  constructor(private _messageService: LocalMessageService<any>,
    private _dialogService: DialogService,
    private _cdr: ChangeDetectorRef) {
  }

  ngOnInit() {
    this._getMessages();
  }

  private _getMessages(): void {
    try {
      this._subscription.add(
        this._messageService. listFiltered('available', true, '==').subscribe((messages) => {
          this.messages = messages;
          this.hasChanges = true;
          this._addMessageRestriction();
  
          setTimeout(() => {
            if (!this.showInformation && this.firstInteraction) {
              this.firstInteraction = false;
              this.auxMessages = this.messages;
              this.toggle();
            }
          }, 1000);

          
          if (this.hasChanges && !this.firstInteraction) {
            this.triggerShake();
            // this._verifyItemChanges();
          }
  
          this._cdr.detectChanges();
        })
      );
    } catch (error) {
      console.error(error);
    }
  }

  public openLinesModal() {
    this._ref = this._dialogService.open(
      TransportMapComponent, {
      position: 'bottom'
    }
    );

    this._ref.onClose.subscribe(() => {
      document.querySelectorAll('.p-dialog-mask').forEach((el) => el.remove());
    });
  }

  private _addMessageRestriction(): void {
    this.messages = [this._getTimeWithDayInfo(), ...this.messages];
  }

  public triggerShake() {
    this.isShaking = true;
    setTimeout(() => this.isShaking = false, 5000);
  }

  public toggle(showChanges?: boolean) {
    this.showInformation = !this.showInformation;

    if (showChanges) {
      this.hasChanges = false;
    }

    this._cdr.detectChanges();
  }

  public openAction(message: any) {
    if (message.project) {
      let project = getInformation(message.project);
      this._executeAction(project);
    } else {
      this.openLink(message.link);
    }
  }

  private _executeAction(project: any) {
    if (project?.mapInfo) {
      this._openMapModal(project);
    }
    if (project.slug === 'app-innova') {
      let banner = getInformation('innova');
      banner.action();
    }
  }

  private _openMapModal(project: any) {
    this._ref = this._dialogService.open(
      MapPreviewComponent, {
      data: {
        mapInfo: project?.mapInfo,
        mapId: project?.slug
      },
      position: 'bottom'
    }
    );

    this._ref.onClose.subscribe(() => {
      document.querySelectorAll('.p-dialog-mask').forEach((el) => el.remove());
    });
  }

  public openLink(link: string) {
    window.open(link);
  }

  private _getTimeWithDayInfo(): any {
    const dayOfWeek = new Date().getDay();
    let message = {
      actionLabel: 'Ver más',
      available: true,
      iconClass: 'bi bi-exclamation-triangle-fill ci-txt--yellow-traffic',
      link: '',
      priority: 2,
      text: '',
      title: 'Restricción vehicular',
      type: 'warning',
      project: 'parking'
    };

    switch (dayOfWeek) {
      case 1: // Lunes
        message.text = "Hoy las placas con terminación: 0 y 1 NO entran al centro.";
        break;
      case 2: // Martes
        message.text = "Hoy las placas con terminación: 2 y 3 NO entran al centro.";
        break;
      case 3: // Miércoles
        message.text = "Hoy las placas con terminación: 4 y 5 NO entran al centro.";
        break;
      case 4: // Jueves
        message.text = "Hoy las placas con terminación: 6 y 7 NO entran al centro.";
        break;
      case 5: // Viernes
        message.text = "Hoy las placas con terminación: 8 y 9 NO entran al centro.";
        break;
      default:
        message.text = "Sin restricción vehicular ¡Feliz fin de semana!";
    }

    return message;
  }
}
